import { createAction } from '@reduxjs/toolkit';

export const clearPatchWarehouseParts = createAction('clearPatchWarehouseParts');
export const clearPostWarehouseParts = createAction('clearPostWarehouseParts');
export const clearDeleteWarehouseParts = createAction('clearDeleteWarehouseParts');
export const setWarehouseParts = createAction('setWarehouseParts');
export const removeWarehousePart = createAction('removeWarehousePart');
